// extracted by mini-css-extract-plugin
export var filterIncDec = "_e5-0";
export var leftBorder = "_e5-1";
export var rightBorder = "_e5-2";
export var stringInput = "_e5-3";